import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Features from "components/features/ThreeColWithSideImage.js";
import Footer from "components/footers/MiniCenteredFooter";
import Hero from "components/hero/PrintPageHero.js";
import PrintService from "components/hero/TwoColumnWithInput.js";
import ThreeColSimple from "components/features/ThreeColWithSideImage.js";
import FeatureWithSteps from "components/features/TwoColWithSteps.js";
import macHeroScreenshotImageSrc from "images/6851378_28342.png";
import VerticalWithAlternateImageAndText from "components/features/VerticalWithAlternateImageAndText";
const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;

const HighlightedText = tw.span`text-primary-500`;

const Container = tw.div`relative bg-primary-900 -mx-8 px-8 text-gray-100`;
export default function PrintPage() {
    return (
        <AnimationRevealPage>
            <Hero />
            {/* <ThreeColSimple /> */}
            {/* <FeatureWithSteps
                subheading={<Subheading>STEPS</Subheading>}
                heading={
                    <>
                        How It <HighlightedText>Works.</HighlightedText>
                    </>
                }
                textOnLeft={false}
                imageSrc={macHeroScreenshotImageSrc}
                imageDecoratorBlob={true}
                decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
            /> */}
            {/* <VerticalWithAlternateImageAndText /> */}
            <PrintService />
            <Footer />
        </AnimationRevealPage>
    );
}
